import React from "react";
import { Handle, Position } from "@xyflow/react";
import type { DependencyGraphNode } from "../../../models";
import "./ActivityNode.css";

export interface ActivityNodeData extends DependencyGraphNode {
  [key: string]: unknown;
}

const ActivityNode: React.FC<{ data: ActivityNodeData }> = ({ data }) => {
  const encoding = [data.takt_a, data.takt_b, data.takt_c, data.work_code]
    .filter(Boolean)
    .join("-");

  const isComplete = data.status === "TK_Complete";
  const hasDates = Boolean(data.start) && Boolean(data.finish);

  const cls = [
    "depgraph-node",
    data.external ? "depgraph-node--external" : "",
    data.is_critical ? "depgraph-node--critical" : "",
    data.is_entry_point ? "depgraph-node--entry" : "",
    isComplete ? "depgraph-node--complete" : "",
    !hasDates ? "depgraph-node--no-dates" : "",
    !data.fill ? "depgraph-node--no-color" : "",
  ]
    .filter(Boolean)
    .join(" ");

  const durationDisplay = Number.isInteger(data.duration_days)
    ? `${data.duration_days}d`
    : `${data.duration_days.toFixed(1)}d`;

  const style = data.fill ? { background: data.fill, color: data.font } : undefined;

  return (
    <div className={cls} style={style} title={data.task_name}>
      <Handle type="target" position={Position.Left} className="depgraph-handle" />
      {isComplete && <span className="depgraph-node-done-badge">✓</span>}
      <div className="depgraph-node-name">{data.task_name || data.task_code}</div>
      <div className="depgraph-node-encoding">{encoding}</div>
      <div className="depgraph-node-dates">
        {hasDates
          ? `${data.start} → ${data.finish} (${durationDisplay})`
          : "⚠ no dates"}
      </div>
      <Handle type="source" position={Position.Right} className="depgraph-handle" />
    </div>
  );
};

export default React.memo(ActivityNode);
